import { render, staticRenderFns } from "./historylist.vue?vue&type=template&id=4bb073df&scoped=true"
import script from "./historylist.vue?vue&type=script&lang=js"
export * from "./historylist.vue?vue&type=script&lang=js"
import style0 from "./historylist.vue?vue&type=style&index=0&id=4bb073df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb073df",
  null
  
)

export default component.exports